import Styled from 'styled-components';

export const TableRowHeader = Styled.div`
display: flex;
justify-content: stretch;
align-items: flex-end;
background: white;
/* width: auto; */
height: 100%;
z-index:3;
${props => (props.stickyTopPosition !== null ? 'position:sticky;' : '')};
${props => (props.stickyTopPosition !== null ? 'top:' + props.stickyTopPosition + 'px;' : '')};
`;

export const BaseLevelHeaderStyle = Styled.div`
box-sizing: border-box;
padding-bottom: 8px;
display: flex;
align-items: flex-end;
justify-content: flex-start;
height: 36px;
width: 166px;
background: white;
color: #a1a1a1;
font-weight: 65Md;
line-height: 1.22;
letter-spacing: 1px;
font-size: 9px;
text-transform: uppercase;
padding-left: 16px;
`;
